import React from 'react';
import miscUtils from 'utils/miscUtils';
import styled from 'styled-components';
import { IPlansBlockPlanPreviewProps } from './IPlansBlockPlanPreviewProps';
import CheckIcon from "containers/PlanSelection/PlanBenefits/icons/CheckIcon";
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import { ButtonAction, scrollElementIntoView, SellableTypes, ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';
import BlockButton from '../../BlockComponents/BlockButton';

const PLAN_DESCRIPTION_CHARACTER_LIMIT: number = 200;

const PriceInBlockWrapper: any = styled.div<{design: any}>`
  flex: 0 1 calc((100% - 40px) / 2);
  border-radius: ${(props: any) => 
    props.design.plan_container_border_radius ?
    `${props.design.plan_container_border_radius}px` :
    `.5rem`
  };
  border-width: ${(props: any) => 
    props.design.plan_container_border_width ?
    `${props.design.plan_container_border_width}px` :
    `1px`
  };
  border-style: solid;
  border-color: ${(props: any) =>
      props.design.plan_container_border_color &&
      isValidHexColor(props.design.plan_container_border_color) ?
      props.design.plan_container_border_color :
      '#D5D8DF'
  };
  background-color: ${(props: any) => 
      props.design.plan_container_background_color &&
      isValidHexColor(props.design.plan_container_background_color) ?
      props.design.plan_container_background_color :
      '#FFFFFF'
  };
  box-shadow: ${(props: any) => 
      props.design.plan_container_shadow_color &&
      isValidHexColor(props.design.plan_container_shadow_color) ?
      props.design.plan_container_shadow_position === ShadowPosition.Even ?
      `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.Bottom ?
      `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.Top ?
      `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.BottomRight ?
      `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.BottomLeft ?
      `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.TopRight ?
      `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      props.design.plan_container_shadow_position === ShadowPosition.TopLeft ?
      `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.plan_container_shadow_color)!.b}, ${props.design.plan_container_shadow_opacity ? props.design.plan_container_shadow_opacity : 0.0})` :
      'none'
      :
      'none'
  };
	overflow: hidden;
	cursor: pointer;
  padding: 25px;
  display: flex;
  flex-direction: column;

	&.mobile {
		flex: 0 0 100%;
	}

	@media(max-width: 768px) {
		flex: 0 0 100%;
	}
`;

const PriceInBlockContainer: any = styled.div<{design: any, buildingPreview: boolean}>`
  width: 100%;
`;

const PriceInBlockContentContainer: any = styled.div<{design: any}>`
  width: 100%;

  &.mobile {
      padding: 0 10px;
  }

  @media(max-width: 550px) {
      padding: 0 10px;
  }
`;

const PriceInBlockContentTitle: any = styled.h3<{design: any, pageStyles: any}>`
  margin: 0;
  padding: 0;
  font-weight: 700;

  font-size: ${(props: any) =>
    props.design.plan_name_font_size &&
    props.design.plan_name_font_size <= 50 ?
    `${props.design.plan_name_font_size}px` :
    `18px`
  };
  line-height: ${(props: any) =>
    props.design.plan_name_line_height &&
    props.design.plan_name_line_height <= 50 ?
    `${props.design.plan_name_line_height}px` :
    `22px`
  };
  font-family: ${(props: any) =>
    props.design.plan_name_font_family ?
    `${props.design.plan_name_font_family} !important` :
    `-apple-system, Arial !important`
  };
  color: ${(props: any) => 
    props.design.plan_name_color &&
    isValidHexColor(props.design.plan_name_color) ?
    props.design.plan_name_color :
    '#000000'
  };
  transition: .5s;

  &:hover {
    color: ${(props: any) => 
      props.design.plan_name_color_hover &&
      isValidHexColor(props.design.plan_name_color_hover) ?
      props.design.plan_name_color_hover  :
      '#365DE6'
    };
  }
`;

const PriceInBlockContentDescription: any = styled.h3<{design: any, pageStyles: any}>`
  margin: 0;
  padding: 0;
  margin-top: 15px;
  font-weight: 400;

  font-size: ${(props: any) =>
    props.design.plan_description_font_size &&
    props.design.plan_description_font_size <= 50 ?
    `${props.design.plan_description_font_size}px` :
    `18px`
  };
  line-height: ${(props: any) =>
    props.design.plan_description_line_height &&
    props.design.plan_description_line_height <= 50 ?
    `${props.design.plan_description_line_height}px` :
    `22px`
  };
  font-family: ${(props: any) =>
    props.design.plan_description_font_family ?
    `${props.design.plan_description_font_family} !important` :
    `-apple-system, Arial !important`
  };
  color: ${(props: any) => 
    props.design.plan_description_color &&
    isValidHexColor(props.design.plan_description_color) ?
    props.design.plan_description_color :
    '#000000'
  };
  transition: .5s;

  &:hover {
    color: ${(props: any) => 
      props.design.plan_description_color_hover &&
      isValidHexColor(props.design.plan_description_color_hover) ?
      props.design.plan_description_color_hover  :
      '#365DE6'
    };
  }
`;

// const PriceInBlockContentText: any = styled.p<{design: any, pageStyles: any}>`
//   margin: 0;
//   padding: 0;
//   margin-top: 10px;
//   font-weight: 400;

//   font-size: ${(props: any) =>
//     props.design.price_subtext_p_font_size &&
//     props.design.price_subtext_p_font_size <= 50 ?
//     `${props.design.price_subtext_p_font_size}px` :
//     `20px`
//   };
//   line-height: ${(props: any) =>
//     props.design.price_subtext_p_line_height &&
//     props.design.price_subtext_p_line_height <= 50 ?
//       `${props.design.price_subtext_p_line_height}px` :
//       `25px`
//   };
//   font-family: ${(props: any) =>
//     props.design.price_subtext_p_font_family ?
//       `${props.design.price_subtext_p_font_family} !important` :
//       `-apple-system, Arial !important`
//   };
//   color: ${(props: any) =>
//     props.design.price_subtext_p_color &&
//     isValidHexColor(props.design.price_subtext_p_color) ?
//     props.design.price_subtext_p_color :
//     props.design.price_subtext_color && 
//     isValidHexColor(props.design.price_subtext_color) ?
//     props.design.price_subtext_color :
//     '#000000'
//   };
// `;

const PriceInBlockPriceContainer: any = styled.div`
  width: 100%;
  margin-top: 15px;
`;

const PriceInBlockPriceText: any = styled.h3<{design: any, pageStyles: any}>`
  margin: 0;
  padding: 0;
  font-weight: 700;

  font-size: ${(props: any) =>
    props.design.plan_price_font_size &&
    props.design.plan_price_font_size <= 50 ?
    `${props.design.plan_price_font_size}px` :
    `18px`
  };
  line-height: ${(props: any) =>
    props.design.plan_price_line_height &&
    props.design.plan_price_line_height <= 50 ?
    `${props.design.plan_price_line_height}px` :
    `22px`
  };
  font-family: ${(props: any) =>
    props.design.plan_price_font_family ?
    `${props.design.plan_price_font_family} !important` :
    `-apple-system, Arial !important`
  };
  color: ${(props: any) => 
    props.design.plan_price_color &&
    isValidHexColor(props.design.plan_price_color) ?
    props.design.plan_price_color :
    '#000000'
  };
  transition: .5s;

  &:hover {
    color: ${(props: any) => 
      props.design.plan_price_color_hover &&
      isValidHexColor(props.design.plan_price_color_hover) ?
      props.design.plan_price_color_hover  :
      '#365DE6'
    };
  }

  span:nth-child(2) {
      font-size: ${(props: any) =>
      props.design.plan_price_font_size &&
      props.design.plan_price_font_size <= 50 ?
      `${props.design.plan_price_font_size - 4}px` :
      `14px`
    } !important;
    line-height: ${(props: any) =>
      props.design.plan_price_line_height &&
      props.design.plan_price_line_height <= 50 ?
      `${props.design.plan_price_line_height - 4}px` :
      `18px`
    } !important;
  }
`;

const BenefitsWrapper: any = styled.div`
  margin-top: 25px;
  padding-top: 25px;

  border: 1px solid transparent;
  border-top-width: ${(props: any) => 
    props.design.plan_container_border_width ?
    `${props.design.plan_container_border_width}px` :
    `1px`
  };
  border-style: solid;
  border-top-color: ${(props: any) =>
      props.design.plan_container_border_color &&
      isValidHexColor(props.design.plan_container_border_color) ?
      props.design.plan_container_border_color :
      '#D5D8DF'
  };
`;

const BenefitsTitle: any = styled.p<{design: any}>`
  margin: 0;
  padding: 0;
  font-weight: bold;
  margin-bottom: 25px;

  font-size: ${(props: any) =>
    props.design.plan_benefits_title_font_size &&
    props.design.plan_benefits_title_font_size <= 50 ?
    `${props.design.plan_benefits_title_font_size}px` :
    `18px`
  };
  line-height: ${(props: any) =>
    props.design.plan_benefits_title_line_height &&
    props.design.plan_benefits_title_line_height <= 50 ?
    `${props.design.plan_benefits_title_line_height}px` :
    `22px`
  };
  font-family: ${(props: any) =>
    props.design.plan_benefits_title_font_family ?
    `${props.design.plan_benefits_title_font_family} !important` :
    `-apple-system, Arial !important`
  };
  color: ${(props: any) => 
    props.design.plan_benefits_title_color &&
    isValidHexColor(props.design.plan_benefits_title_color) ?
    props.design.plan_benefits_title_color :
    '#000000'
  };
  transition: .5s;

  &:hover {
    color: ${(props: any) => 
      props.design.plan_benefits_title_color_hover &&
      isValidHexColor(props.design.plan_benefits_title_color_hover) ?
      props.design.plan_benefits_title_color_hover  :
      '#365DE6'
    };
  }
`;

const BenefitsContainer: any = styled.div`
`;

const BenefitsItem: any = styled.p`
    font-weight: 400;
    letter-spacing: 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }

    font-size: ${(props: any) =>
      props.design.plan_benefits_text_font_size &&
      props.design.plan_benefits_text_font_size <= 50 ?
      `${props.design.plan_benefits_text_font_size}px` :
      `18px`
    };
    line-height: ${(props: any) =>
      props.design.plan_benefits_text_line_height &&
      props.design.plan_benefits_text_line_height <= 50 ?
      `${props.design.plan_benefits_text_line_height}px` :
      `22px`
    };
    font-family: ${(props: any) =>
      props.design.plan_benefits_text_font_family ?
      `${props.design.plan_benefits_text_font_family} !important` :
      `-apple-system, Arial !important`
    };
    color: ${(props: any) => 
      props.design.plan_benefits_text_color &&
      isValidHexColor(props.design.plan_benefits_text_color) ?
      props.design.plan_benefits_text_color :
      '#000000'
    };
    transition: .5s;

    &:hover {
      color: ${(props: any) => 
        props.design.plan_benefits_text_color_hover &&
        isValidHexColor(props.design.plan_benefits_text_color_hover) ?
        props.design.plan_benefits_text_color_hover :
        '#365DE6'
      };
    }
`;

const BenefitsIconContainer: any = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const PlanButtonContainer: any = styled.div`
    width: 100%;
    margin-top: auto;
    margin-bottom: 0;
    padding-top: 15px;
`;

const PlanButton: any = styled(BlockButton)`
    width: 100%;
`;

const PlansBlockPlanPreview: React.FC<IPlansBlockPlanPreviewProps> = (props) => {

   const getPlanURL = () => {
    if(props.plan.type === SellableTypes.PLAN) {
      const plan_url = `${props.group.url}/plan-subscription/checkout?plan=${props.plan.original_item && props.plan.original_item.uuid}`;
      return plan_url;
    }

    let resourceCheckoutURL: string = "";
    switch(props.plan.type) {
        case SellableTypes.COURSE:
        case SellableTypes.EVENT:
            resourceCheckoutURL = `${props.group.url}/${props.plan.type}/${props.plan.original_item.parent_resource_slug}/purchase?payment_option=${props.plan.original_item && props.plan.original_item.slug}`;
            break;
        case SellableTypes.EMBED:
        case SellableTypes.AUDIO:
        case SellableTypes.VIDEO:
        case SellableTypes.PDF:
        case SellableTypes.ARTICLE:
            resourceCheckoutURL = `${props.group.url}/library/${props.plan.type}/${props.plan.original_item.parent_resource_slug}/purchase?payment_option=${props.plan.original_item && props.plan.original_item.slug}`;
            break;
        default:
            break;
    }

    return resourceCheckoutURL;
   }

    const ctaOnClick = (e: any) => {
        e.stopPropagation();
        
        if(props.buildingPreview) {
            return;
        }

        if(
          props.plan &&
          props.plan.redirect_action === ButtonAction.Default
        ) {
              window.open(
                getPlanURL(),
                '_self'
              );
              return;
        }
        
        if(
            props.plan &&
            (
                props.plan.redirect_action === ButtonAction.URL ||
                props.plan.redirect_action === ButtonAction.URLTab
            ) &&
            props.plan.redirect_url
        ) {
            window.open(
                miscUtils.ensureHttps(props.plan.redirect_url),
                props.plan.redirect_action === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }

        if(
            props.plan &&
            props.plan.redirect_action === ButtonAction.Scroll &&
            props.plan.redirect_url &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${props.plan.redirect_url}`);
            return;
        }

        if(
            props.plan &&
            props.plan.redirect_action === ButtonAction.Popup &&
            props.plan.redirect_url
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

            nextPageFormsOpenState[props.plan.redirect_url] = true;

            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            props.plan &&
            props.plan.redirect_action === ButtonAction.Page &&
            props.plan.redirect_url
        ) {
            window.open(
                `${props.plan.redirect_url}`, 
                '_self'
            );
            return;
        }
    }

    if(
      !props.plan.original_item ||
      (
        props.plan.original_item &&
        props.plan.type !== SellableTypes.PLAN &&
        !props.plan.original_item.parent_resource_slug
      )
    ) {
      return <></>
    }

  return (
    <PriceInBlockWrapper
    className={props.view ? `${props.view}` : ''}
    design={props.blockData.design}
    onClick={ctaOnClick}
    >
        <PriceInBlockContainer
        design={props.blockData.design}
        buildingPreview={props.buildingPreview}
        >
            <PriceInBlockContentContainer
            className={`${props.view ? props.view : ''}`}
            design={props.blockData.design}
            >
                <PriceInBlockContentTitle
                design={props.blockData.design}
                pageStyles={props.pageStyles}
                >
                    {props.plan.original_item && props.plan.original_item.name}
                </PriceInBlockContentTitle>

                {props.plan.original_item && props.plan.original_item.description ? (
                  <PriceInBlockContentDescription
                  design={props.blockData.design}
                  pageStyles={props.pageStyles}
                  >
                      {miscUtils.truncateString(props.plan.original_item && props.plan.original_item.description, PLAN_DESCRIPTION_CHARACTER_LIMIT)}
                  </PriceInBlockContentDescription>
                ) : <></>}
            </PriceInBlockContentContainer>

            <PriceInBlockPriceContainer
            className={`${props.view ? props.view : ''}`}
            >
                <PriceInBlockPriceText
                design={props.blockData.design}
                pageStyles={props.pageStyles}
                >
                  <span
                  >
                      {miscUtils.getCurrencySymbol(props.plan.original_item && props.plan.original_item.currency)}{props.plan.original_item && props.plan.original_item.price}{" "}{props.plan.original_item && props.plan.original_item.currency.toUpperCase()}
                  </span>
                  <span
                  >
                    {miscUtils.getPlanInterval(props.plan.original_item && props.plan.original_item)}
                  </span>
                </PriceInBlockPriceText>
            </PriceInBlockPriceContainer>
        </PriceInBlockContainer>

        {props.plan && props.plan.original_item && props.plan.original_item.benefits && props.plan.original_item.benefits.length ? (
              <BenefitsWrapper
              design={props.blockData.design}
              >
                <BenefitsTitle
                design={props.blockData.design}
                >
                  {props.plan.original_item && props.plan.original_item.name} includes
                </BenefitsTitle>
                  <BenefitsContainer
                  >
                      {
                          props.plan &&
                          props.plan.original_item && 
                          props.plan.original_item.benefits &&
                          props.plan.original_item.benefits.sort((a: any, b: any) => a.position - b.position) // Sorting by position
                          .map((benefit: any, i: any) => {
                          return (
                          <BenefitsItem
                          key={i}
                          design={props.blockData.design}
                          >
                              <BenefitsIconContainer
                              >
                                  <CheckIcon
                                  fill={
                                    props.blockData.design.plan_benefits_icon_color &&
                                    isValidHexColor(props.blockData.design.plan_benefits_icon_color) ?
                                    props.blockData.design.plan_benefits_icon_color :
                                    '#365DE6'
                                  }
                                  />
                              </BenefitsIconContainer>{" "}
                              {benefit.benefit}
                          </BenefitsItem>
                          );
                      })}
                  </BenefitsContainer>
              </BenefitsWrapper>
        ) : <></>}

        <PlanButtonContainer
        >
          <PlanButton
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          onClick={ctaOnClick}
          >
            {props.plan.button_text || `[Set Button Text]`}
          </PlanButton>
        </PlanButtonContainer>
    </PriceInBlockWrapper>
  )
}

export default PlansBlockPlanPreview;